<ng-container *ngIf="mobile; else desktop" [caLocalizationScope]="L10N">
  <ng-container *ngFor="let inst of institutions; let first = first; let last = last">
    <ng-container *ngTemplateOutlet="profileLinkTemplate; context: { $implicit: inst, first: first }"></ng-container>
    <span *ngIf="inst.isPrimary && institutions.length > 1" class="badge badge-xxs badge-accent-2">
      {{ 'primary' | caLocalize }}
    </span>
    <ng-container *ngIf="!last">, </ng-container>
  </ng-container>
</ng-container>

<ng-template #desktop>
  <div class="d-flex">
    <ng-container *ngTemplateOutlet="profileLinkTemplate; context: { $implicit: institutions[0] }"></ng-container>

    <span
      *ngIf="institutions.length > 1"
      fMobilePopover
      [ngbPopover]="popoverTemplate"
      [mobilePopoverTitle]="popoverTitle"
      [caLocalizationScope]="L10N"
      class="link link-primary ms-0 ms-sm-1"
      popoverClass="popover-with-scroll"
      placement="bottom-right"
      data-automation-id="show-all-link"
    >
      {{ 'showAll' | caLocalize }}
    </span>
  </div>
</ng-template>

<ng-template #popoverTemplate>
  <ul class="list-unstyled mb-0 ca-participant-popover">
    <li *ngFor="let inst of institutions" [caLocalizationScope]="L10N" class="d-flex justify-content-between me-2">
      <ng-container *ngTemplateOutlet="profileLinkTemplate; context: { $implicit: inst }"></ng-container>
      <span *ngIf="inst.isPrimary" class="badge badge-xxs badge-accent-2">{{ 'primary' | caLocalize }}</span>
    </li>
  </ul>
</ng-template>

<ng-template #profileLinkTemplate let-inst let-first="first">
  <ca-profile-preview-link
    [prId]="inst.id"
    [text]="inst.name"
    [type]="'Institution'"
    class="link link-main ps-0 ps-sm-2 pe-0 pe-sm-4 text-desktop-truncate"
    [class.pe-1]="first"
    data-automation-id="single-institution-profile-link-preview"
  >
  </ca-profile-preview-link>
</ng-template>
